<template lang="html">
  <div class="">
    <search-form :ruleForm="ruleForm" @search="search" />
    <bill-table ref="billTable" :ruleForm="ruleForm" />
  </div>
</template>

<script>
import searchForm from "./components/searchForm";
import billTable from "./components/billTable";
export default {
  data() {
    return {
      ruleForm: {
        realTotalMoney: {
          type: 0,
          start: "",
          end: ""
        },
        createTime: [],
        receiptAndPaymentStatus: -1,
        billType: 1
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    search() {
      this.$refs.billTable.getDataList(true);
    }
  },
  watch: {},
  components: {
    searchForm,
    billTable
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/personal/bill/index.vue